/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_DescriptionInputs */

const en_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description`)
};

const fr_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description audio`)
};

const de_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung`)
};

const it_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione audio`)
};

const ru_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописание`)
};

const es_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de audio`)
};

const zh_cn2_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明`)
};

const hi_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_audio_description = /** @type {(inputs: Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição em áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description = /** @type {((inputs?: Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description(inputs)
	if (locale === "de") return de_audio_description(inputs)
	if (locale === "it") return it_audio_description(inputs)
	if (locale === "ru") return ru_audio_description(inputs)
	if (locale === "es") return es_audio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description(inputs)
	if (locale === "ja") return ja_audio_description(inputs)
	if (locale === "hi") return hi_audio_description(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description(inputs)
	return en_audio_description(inputs)
});